// extracted by mini-css-extract-plugin
export default {"modal_content":"DBSPaymentAgrModal_modal_content__xeHSq"};